<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="desserts"
      height="70vh"
      :items-per-page="500"
      :footer-props="{
        itemsPerPageOptions: [500, 1000, 2000, 3000, 4000],
      }"
      :search="search"
      :fixed-header="true"
      :options.sync="options"
      class="elevation-3"
    >
      <!-- Slot para a coluna ID -->
      <template v-slot:item.idpessoa="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.idpessoa }}
        </span>
      </template>

      <!-- Slot para a coluna Nome Completo -->
      <template v-slot:item.nome_completo="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.nome_completo }}
        </span>
      </template>

      <!-- Slot para a coluna Telefone -->
      <template v-slot:item.telefone="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.telefone }}
        </span>
      </template>

      <!-- Slot para a coluna Email -->
      <template v-slot:item.email="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.email }}
        </span>
      </template>

      <!-- Slot para a coluna Assessor -->
      <template v-slot:item.assessor.name="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.assessor.name }}
        </span>
      </template>

      <!-- Slot para a coluna Cad.Duplicado -->
      <template v-slot:item.cad_dup="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{
            item.cad_dup === 1
              ? "REGISTRO DUPLICADO REMOVER"
              : "REGISTRO VALIDADO"
          }}
        </span>
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title
            >Cadastro de Pessoas - {{ metas.total_cad }} /
            {{ metas.total }}</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>

          <v-icon
            v-if="metas.total_cad > 0"
            title="Imprimir Lista de Cadastro"
            class="mr-5"
            @click="getReportAssessor"
            >mdi-printer</v-icon
          >
          <v-btn
            v-if="metas.show"
            small
            rounded
            color="primary"
            dark
            class="mb-2"
            @click="dialog = true"
            >Novo</v-btn
          >

          <v-dialog persistent v-model="dialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.nome_completo"
                        counter
                        label="Nome Completo*"
                        :error-messages="nameErrors"
                        @input="$v.editedItem.nome_completo.$touch()"
                        @blur="$v.editedItem.nome_completo.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.zona"
                        :items="selects.zonas.items"
                        item-text="zona"
                        item-value="zona"
                        chips
                        label="Selecione Zona*"
                        height="10"
                        outlined
                        style="margin-right: 5px"
                        :error-messages="zonaErrors"
                        @input="$v.editedItem.zona.$touch()"
                        @blur="$v.editedItem.zona.$touch()"
                      ></v-select>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.secao"
                        label="Seção*"
                        style="margin-left: 5px"
                        :error-messages="secaoErrors"
                        v-mask="'####'"
                        @input="$v.editedItem.secao.$touch()"
                        @blur="$v.editedItem.secao.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.telefone"
                        label="Telefone*"
                        style="margin-left: 5px"
                        prepend-inner-icon="mdi-phone"
                        :error-messages="telefoneErrors"
                        v-mask="'(##) #####-####'"
                        @input="$v.editedItem.telefone.$touch()"
                        @blur="$v.editedItem.telefone.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.email"
                        label="Email"
                        prepend-inner-icon="mdi-email"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email.$touch()"
                        @blur="$v.editedItem.email.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.facebook"
                        prepend-inner-icon="mdi-facebook"
                        label="Facebook"
                        style="margin-right: 5px"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.instagram"
                        prepend-inner-icon="mdi-instagram"
                        label="Instagram"
                        style="margin-right: 5px"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Usuário" class="mr-2" @click="editItem(item)"
          >mdi-pencil</v-icon
        >
        <v-icon title="Remover Usuário" @click="deleteItem(item)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "idpessoa",
      },
      {
        text: "Nome Completo",
        align: "left",
        value: "nome_completo",
      },

      { text: "Telefone", value: "telefone" },
      { text: "Email", value: "email" },
      { text: "Assessor", value: "assessor.name" },
      { text: "Análise de Cadastro", value: "cad_dup" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    options: {
      sortBy: ["cad_dup"], // Definindo para ordenar pela coluna cad_dup inicialmente
      sortDesc: [true], // Definindo a direção da ordenação (false para crescente)
    },
    editedIndex: -1,
    selects: {
      perfil: {
        items: [],
      },
      candidatos: {
        items: [],
      },
      zonas: {
        value: 0,
        items: [],
      },
    },
    editedItem: {
      id: "",
      nome_completo: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
    },
    defaultItem: {
      id: "",
      nome_completo: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
    },
    metas: {
      total: "",
      total_cad: "",
      show: true,
    },
  }),

  validations: {
    editedItem: {
      nome_completo: {
        required,
        minLength: minLength(6),
      },
      email: {
        email,
      },
      telefone: {
        required,
        isPhoneNumber: helpers.regex(
          "telefone",
          /^\(([0-9]{2})\) 9([0-9])(?!\2{3}-(\2{4}))([0-9]{3})-([0-9]{4})$/
        ),
      },

      zona: {
        required,
      },
      secao: {
        required,
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.nome_completo.$dirty) return errors;
      !this.$v.editedItem.nome_completo.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.nome_completo.minLength &&
        errors.push("Nome Completo  dever ser maior que 6 caracteres");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.telefone.isPhoneNumber &&
        errors.push("Número de Telefone fora do Padrão");
      return errors;
    },
    zonaErrors() {
      const errors = [];
      if (!this.$v.editedItem.zona.$dirty) return errors;
      !this.$v.editedItem.zona.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    secaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.secao.$dirty) return errors;
      !this.$v.editedItem.secao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Pessoa" : "Editar Pessoa";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      //Filtro Usuarios da Equipe caso tenha
      const id_assessor = localStorage.getItem("id");

      const params = {
        id_assessor: id_assessor,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getPessoas(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.pessoas;
              this.metas.total = parseFloat(response.data.metas.meta);
              this.metas.total_cad = parseFloat(response.data.total_cadastros);

              if (this.metas.total_cad < this.metas.total) {
                this.metas.show = true;
              } else {
                this.metas.show = false;
              }

              this.buscaZonas();
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.setZona(item.zona);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover pessoa?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delPessoa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    getReportAssessor() {
      const id_assessor = localStorage.getItem("id");
      const equipe = localStorage.getItem("id");

      let url = "relatorio_assessores?id=" + id_assessor + "&id_cd=" + equipe;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    save() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const id_assessor = localStorage.getItem("id");

        this.editedItem.id_assessor = id_assessor;

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.addPessoa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );

        this.close();
      }
    },

    buscaZonas() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getZonas(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.zonas.items = [];

          if (response.status == 200) {
            this.selects.zonas.items = response.data.zonas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    setZona(zona) {
      if (zona != "null") {
        this.editedItem.zona = parseInt(zona);
        this.selects.zonas.ativado = true;
      }
    },
  },
};
</script>
<style scoped>
</style>